module.exports = __webpack_public_path__ + "5224456b529e1009d6caf6b119f7423b.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/goldencity2.jpg
// module id = 630
// module chunks = 0